module.exports = __webpack_public_path__ + "img/consult_entrance.509fb1be.png";